import { employeeSkills, skills } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

// Skill schemas
export const selectSkillSchema = createSelectSchema(skills)
export const insertSkillSchema = createInsertSchema(skills).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})
export const updateSkillSchema = insertSkillSchema.partial()

// Employee skill schemas
export const selectEmployeeSkillSchema = createSelectSchema(employeeSkills)
export const insertEmployeeSkillSchema = z.object({
  skillId: z.number(),
  level: z.enum(['beginner', 'intermediate', 'expert']),
})

// Skill with relation for display
export const selectSkillWithRelationSchema = selectSkillSchema

// Employee skill with skill details for display
export const selectEmployeeSkillWithDetailsSchema =
  selectEmployeeSkillSchema.extend({
    skill: selectSkillSchema,
  })

// Type exports
export type Skill = z.infer<typeof selectSkillSchema>
export type CreateSkill = z.infer<typeof insertSkillSchema>
export type UpdateSkill = z.infer<typeof updateSkillSchema>
export type EmployeeSkill = z.infer<typeof selectEmployeeSkillSchema>
export type CreateEmployeeSkill = z.infer<typeof insertEmployeeSkillSchema>
export type EmployeeSkillWithDetails = z.infer<
  typeof selectEmployeeSkillWithDetailsSchema
>
